<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="square-jelly-box" [fullScreen]="true"><p style="color:white"> Chargement... </p></ngx-spinner>
<router-outlet></router-outlet>

